import {ChangeDetectionStrategy, Component, Injector} from '@angular/core';
import {AuthService} from 'compob2b-auth';
import {BaseComponent, Cart, CartEventService, CartLocalService, CartRemoteService, CustomerGroup, StoreService} from 'compob2b-libs';
import {filter, switchMap, takeUntil, tap} from 'rxjs/operators';
import {EventCartService} from '../services/event-cart.service';

@Component({
  selector: 'app-basket-header',
  templateUrl: './basket-header.component.html',
  styleUrls: ['./basket-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BasketHeaderComponent extends BaseComponent {

  private cartService: Cart;
  readonly amount$ = this.cartEventService.getAmount();
  readonly cost$ = this.cartEventService.getTotalCostWithVAT();
  readonly replaceCartProduct$ = this.cartEventService.getReplaceCartProduct();
  readonly customerGroup$ = this.storeService.getCustomerGroup();
  customerGroupId = 0;

  constructor(
    injector: Injector,
    private readonly cartEventService: CartEventService,
    private readonly authService: AuthService,
    private readonly storeService: StoreService,
    private readonly eventCartService: EventCartService,
  ) {
    super();

    this.cartService = this.authService.isAnonymous() ?
      injector.get<Cart>(CartLocalService) :
      injector.get<Cart>(CartRemoteService);

    this.customerGroup$.pipe(
      tap(data => this.handleCustomerGroup(data)),
      switchMap(_ => this.getByRegion()),
      takeUntil(this.unsubscribe)
    ).subscribe();

    this.replaceCartProduct$.pipe(
      filter(val => val === true),
      switchMap(_ => this.getByRegion()),
      takeUntil(this.unsubscribe)
    ).subscribe();

    this.eventCartService.on('CartReload', (_data: boolean) => {
      this.getByRegion().pipe(
        tap(_ => this.cdr.detectChanges()),
        takeUntil(this.unsubscribe)
      ).subscribe();
    });
  }

  private getByRegion() {
    return this.cartService.getByRegion(this.customerGroupId);
  }

  private handleCustomerGroup(customerGroup: CustomerGroup) {
    if (customerGroup) {
      this.customerGroupId = customerGroup.id;
    }
  }

  toCart(): void {
    this.router.navigate(['/cart']);
  }

}
